// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.ForRentByType

export enum ForRentByType {
  AGENT = 'AGENT',
  OWNER = 'OWNER',
  OWNER_RESIDENT = 'OWNER_RESIDENT',
  TENANT = 'TENANT',
}

export const ForRentByType_values = [
  ForRentByType.AGENT,
  ForRentByType.OWNER,
  ForRentByType.OWNER_RESIDENT,
  ForRentByType.TENANT,
] as const;
